import { BoxDtoSchema } from "@modules/box/services/boxDto"
import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { UserDtoSchema } from "@modules/profile/userProfile/userDto"
import { ProgramSubscriptionStatus, ProgramVisibility } from "@modules/programs/types/programTypes"
import { z } from "zod"

export const BoxUserProgramItemDtoSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    image: HUImageDtoSchema.nullable(),
    owner: UserDtoSchema.nullable(),
    visibility: z.enum(ProgramVisibility),
    subscribed: z.boolean(),
    subscriptionCount: z.number(),
    subscriptionStatus: z.enum(ProgramSubscriptionStatus).nullable(),
    price: PriceObjectDtoSchema.nullable(),
    subscribedByUser: UserDtoSchema.nullable(),
    subscribedByBox: BoxDtoSchema.nullable(),
  })
  .meta({ id: "BoxUserProgramItemDtoSchema" })

export type BoxUserProgramItemDto = z.infer<typeof BoxUserProgramItemDtoSchema>
